export const LANGUAGE_KEY = 'language';

export const getCookie = (key: string) => {
  if (typeof document !== 'undefined') {
    const value = '; ' + document.cookie;
    const parts = value.split('; ' + key + '=');
    if (parts.length === 2) {
      return parts.pop()!.split(';').shift();
    }
  }
};

export const setCookie = (key: string, value: string | number) => {
  if (typeof document !== 'undefined') {
    document.cookie = `${key}=${value}`;
  }
};
